<template>
   <div>
        <div class="table-wrapper on-767" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">KD ’000</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">Kuwaiti Dinar</div>
                    <div data-width='15%' class="font light-gray"> 59,076</div>
                    <div data-width='15%' class="font">68,424</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">US Dollar</div>
                    <div data-width='15%' class="font light-gray">254,657</div>
                    <div data-width='15%' class="font">288,542</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Bahraini Dinar</div>
                    <div data-width='15%' class="font light-gray">11,360</div>
                    <div data-width='15%' class="font">12,588</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Sudanese Pound</div>
                    <div data-width='15%' class="font light-gray"> 4,908</div>
                    <div data-width='15%' class="font ">5,582</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Jordanian Dinar</div>
                    <div data-width='15%' class="font light-gray">19,761</div>
                    <div data-width='15%' class="font">21,401</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Iraqi Dinar</div>
                    <div data-width='15%' class="font light-gray">66,323</div>
                    <div data-width='15%' class="font ">40,486</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Saudi Riyals</div>
                    <div data-width='15%' class="font light-gray"> 150,458</div>
                    <div data-width='15%' class="font"> 115,125</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Others</div>
                    <div data-width='15%' class="font light-gray">12,743</div>
                    <div data-width='15%' class="font">3,250</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white "> 579,286</div>
                    <div data-width='15%' class=" bold white">555,398</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%' class=""></div>
                    <div data-width='30%' class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">دينار كويتي</div>
                    <div data-width='15%' class="font light-gray"> 59,076</div>
                    <div data-width='15%' class="font">68,424</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">دولار أمريكي</div>
                    <div data-width='15%' class="font light-gray">254,657</div>
                    <div data-width='15%' class="font">288,542</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">دينار بحريني</div>
                    <div data-width='15%' class="font light-gray">11,360</div>
                    <div data-width='15%' class="font">12,588</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">جنيه سوداني</div>
                    <div data-width='15%' class="font light-gray"> 4,908</div>
                    <div data-width='15%' class="font ">5,582</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">دينار أردني</div>
                    <div data-width='15%' class="font light-gray">19,761</div>
                    <div data-width='15%' class="font">21,401</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">دينار عراقي</div>
                    <div data-width='15%' class="font light-gray">66,323</div>
                    <div data-width='15%' class="font ">40,486</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">ريال سعودي</div>
                    <div data-width='15%' class="font light-gray"> 150,458</div>
                    <div data-width='15%' class="font"> 115,125</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">أخرى</div>
                    <div data-width='15%' class="font light-gray">12,743</div>
                    <div data-width='15%' class="font">3,250</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%'></div>
                    <div data-width='15%' class=" bold white "> 579,286</div>
                    <div data-width='15%' class=" bold white">555,398</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>